// extracted by mini-css-extract-plugin
export default {"menu":"NavMenu_menu__Txyl9","navList":"NavMenu_navList__9Z3AD","nav":"NavMenu_nav__KDbtg"};